/**
 * Tenant-profile hooks — the component-side accessors for the tenant's
 * currency / tax / country / locale profile.
 *
 * Fallback chain per field: hydrated profile → persisted last-login profile
 * (same store) → platform-default literal (equal to today's hardcoded
 * behavior, so existing tenants render identically until later phases rewire
 * the display sites onto these hooks).
 */

import { useTenantStore } from '@/stores/tenant-store'

export function useTenantCurrency(): string {
  return useTenantStore((s) => s.profile?.baseCurrency ?? 'AED')
}

export function useTaxLabel(): string {
  return useTenantStore((s) => s.profile?.taxLabel ?? 'VAT')
}

/** Tenant default tax rate in percent (e.g. 5 for UAE VAT, 18 for India GST). */
export function useTaxRate(): number {
  return useTenantStore((s) => s.profile?.defaultTaxRatePercent ?? 5)
}

export function useTaxIdLabel(): string {
  return useTenantStore((s) => s.profile?.taxIdLabel ?? 'TRN')
}

export function useTenantCountry(): string {
  return useTenantStore((s) => s.profile?.country ?? 'AE')
}

export function useTenantLocale(): string {
  return useTenantStore((s) => s.profile?.locale ?? 'en-AE')
}

export function useTenantTimezone(): string {
  return useTenantStore((s) => s.profile?.timezone ?? 'Asia/Dubai')
}

export function useTenantTaxIdValue(): string | null {
  return useTenantStore((s) => s.profile?.taxIdValue ?? null)
}
